import { Link } from "react-router-dom";
import Icon from "assets/png/noble-r.png";
import { FiAlignRight } from "react-icons/fi";
import { useState } from "react";
import { FaTimes } from "react-icons/fa";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="w-full h-[120px] relative">
      <div className="flex w-full fixed h-[120px] bg-white backdrop-blur z-50 justify-between items-center px-8 xl:px-20 xl:pr-32">
        <Link to="/" className="cursor-pointer">
          <img
            src={Icon}
            alt=""
            className="w-[120px] h-[120px] object-contain"
          />
        </Link>
        <ul className="hidden lg:flex gap-10 items-center">
          <li>
            <Link to="/" className="hover:text-blue-100">
              Home
            </Link>
          </li>
          <li>
            <a href="/#services" className="hover:text-blue-100">
              Services
            </a>
          </li>
          <li className="relative group">
            <span className="hover:text-blue-100 cursor-pointer">Arms</span>

            <ul className="absolute hidden group-hover:block py-3">
              <div className="bg-white md-shadow w-fit rounded-lg">
                <li>
                  <a
                    href="https://nobleguard.com.ng/"
                    target="_blank"
                    rel="noreferrer"
                    className="block px-4 py-2 hover:bg-gray-100 whitespace-nowrap"
                  >
                    Noble Guard Group
                  </a>
                </li>
                <li>
                  <a
                    href="https://security.nobleguard.com.ng/"
                    target="_blank"
                    rel="noreferrer"
                    className="block px-4 py-2 hover:bg-gray-100 whitespace-nowrap"
                  >
                    Noble Guard Security
                  </a>
                </li>
                <li>
                  <a
                    href="https://authenticate.nobleguard.com.ng/"
                    target="_blank"
                    rel="noreferrer"
                    className="block px-4 py-2 hover:bg-gray-100 whitespace-nowrap"
                  >
                    Authenticate with Noble Guard
                  </a>
                </li>
              </div>
            </ul>
          </li>
          <li>
            <a href="/blog" className="hover:text-blue-100">
              Blogs
            </a>
          </li>
          <li>
            <a href="/#contact" className="hover:text-blue-100">
              Contact
            </a>
          </li>
        </ul>
        <div
          className="flex lg:hidden cursor-pointer"
          onClick={toggleMobileMenu}
        >
          <FiAlignRight size={24} />
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center">
          <button
            className="absolute top-14 right-8"
            type="button"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FaTimes size={24} />
          </button>
          <ul className="flex flex-col gap-4 items-center">
            <li>
              <Link
                to="/"
                className="hover:text-blue-100"
                onClick={toggleMobileMenu}
              >
                Home
              </Link>
            </li>
            <li>
              <a
                href="/#services"
                className="hover:text-blue-100"
                onClick={toggleMobileMenu}
              >
                Services
              </a>
            </li>

            <li>
              <a
                href="https://nobleguard.com.ng/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-blue-100"
                onClick={toggleMobileMenu}
              >
                Noble Guard Group
              </a>
            </li>

            <li>
              <a
                href="https://security.nobleguard.com.ng/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-blue-100"
                onClick={toggleMobileMenu}
              >
                Noble Guard Security
              </a>
            </li>

            <li>
              <a
                href="https://authenticate.nobleguard.com.ng/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-blue-100"
                onClick={toggleMobileMenu}
              >
                Authenticate with Noble Guard
              </a>
            </li>

            <li>
              <a
                href="/blog"
                className="hover:text-blue-100"
                onClick={toggleMobileMenu}
              >
                Blogs
              </a>
            </li>
            <li>
              <a
                href="/#contact"
                className="hover:text-blue-100"
                onClick={toggleMobileMenu}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
